module.exports = __webpack_public_path__ + "static/media/question-mark-icon.f23ed8e8.svg";